/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Billinggroup2Inputs */

const zh_settingsnav_billinggroup2 = /** @type {(inputs: Settingsnav_Billinggroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计费`)
};

const en_settingsnav_billinggroup2 = /** @type {(inputs: Settingsnav_Billinggroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const es_settingsnav_billinggroup2 = /** @type {(inputs: Settingsnav_Billinggroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Settingsnav_Billinggroup2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_billinggroup2 = /** @type {((inputs?: Settingsnav_Billinggroup2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Billinggroup2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_billinggroup2(inputs)
	if (locale === "en") return en_settingsnav_billinggroup2(inputs)
	return es_settingsnav_billinggroup2(inputs)
});
export { settingsnav_billinggroup2 as "settingsNav_billingGroup" }